/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharekindsignup2Inputs */

const en_sharekindsignup2 = /** @type {(inputs: Sharekindsignup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New account`)
};

const de_sharekindsignup2 = /** @type {(inputs: Sharekindsignup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Konto`)
};

/**
* | output |
* | --- |
* | "New account" |
*
* @param {Sharekindsignup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharekindsignup2 = /** @type {((inputs?: Sharekindsignup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharekindsignup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharekindsignup2(inputs)
	return de_sharekindsignup2(inputs)
});
export { sharekindsignup2 as "shareKindSignup" }